import { format, isDate, toDate } from 'date-fns';

const safeDateFormat = (
  dateProps: unknown,
  formatStr: string,
  fallbackValue = 'Fecha no encontrada.',
) => {
  try {
    if (
      !(dateProps instanceof Date) &&
      typeof dateProps !== 'number' &&
      typeof dateProps !== 'string'
    ) {
      return fallbackValue;
    }

    const date = toDate(dateProps);

    if (!isDate(date)) {
      return fallbackValue;
    }

    return format(date, formatStr);
  } catch (e) {
    console.error('Error formatting date:', e);

    return fallbackValue;
  }
};

export { safeDateFormat };
